import React from "react";
import styled from "styled-components";
import renderIf from "render-if";
import { withTheme } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import isTest from '../utils/isTest'

const Wrapper = withTheme(styled.footer`
  background-color: ${(props) => props.theme.palette.primary.main};
  padding: 20px 25px;
  box-sizing: border-box;
  color: white;
`);

const year = isTest() ? 2022 : new Date().getFullYear()

const AppFooter = ({ removeBranding, ...props }) => (
  <Wrapper {...props}>
    <Typography variant="subtitle2">
      ©{year} {renderIf(!removeBranding)("PURECARS")} ALL RIGHTS RESERVED.
    </Typography>
    <Typography variant="subtitle2">
      <a
        style={{ textDecoration: "none", color: "white" }}
        href="https://www.purecars.com/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
      >
        PRIVACY
      </a>{" "}
      |{" "}
      <a
        style={{ textDecoration: "none", color: "white" }}
        href="https://www.purecars.com/terms-service-agreement/"
        target="_blank"
        rel="noopener noreferrer"
      >
        TERMS &amp; CONDITIONS
      </a>
    </Typography>
  </Wrapper>
);

export default AppFooter;
